exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td, th {\r\n    border: 1px solid #4d4d44;\r\n}\r\nth {\r\n    border-width: 2px;\r\n    color: black;\r\n    font-weight: bold;\r\n    background: #DDEBF7;\r\n}\r\n.blueLight {\r\n    background: #DDEBF7;\r\n    font-weight: bold;\r\n}\r\n.yellow {\r\n    background: #FFFF00;\r\n    font-weight: bold;\r\n}\r\n.red {\r\n    background: #F8CBAD;\r\n}\r\ntd {\r\n    background: #FFFFCC;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/reportes/semanal-2/semanal-2.component.css
// module id = ../../../../../src/app/components/reportes/semanal-2/semanal-2.component.css
// module chunks = main